module.exports = __webpack_public_path__ + "img/polic.58f55c5c.png";